// useFacilitatorStore.js
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { data as initialData } from './pages/fascdummydata';

export const isFacilitatorTrainingUnlockedForTesting = false;

export const useFacilitatorStore = create(
  persist(
    (set) => ({
      data: initialData,
      addGroup: (groupName) =>
        set((state) => {
          const newGroup = {
            id: `G${state.data.groups.length + 1}`,
            name: groupName,
            facilitatorIds: [],
            memberIds: [],
          };
          return {
            data: {
              ...state.data,
              groups: [...state.data.groups, newGroup],
            },
          };
        }),
      addGroupWithFacilitators: (name, facilitatorIds) =>
        set((state) => {
          const newGroupId = `G${String(state.data.groups.length + 1).padStart(
            3,
            '0',
          )}`;
          const newGroup = {
            id: newGroupId,
            name,
            facilitatorIds,
            memberIds: [],
          };

          return {
            data: {
              ...state.data,
              groups: [...state.data.groups, newGroup],
            },
          };
        }),
      createGroupWithAssignments: (name, facilitatorIds, memberIds) =>
        set((state) => {
          const newGroupId = `G${String(state.data.groups.length + 1).padStart(
            3,
            '0',
          )}`;
          const selectedMemberIds = Array.isArray(memberIds) ? memberIds : [];
          const newGroup = {
            id: newGroupId,
            name,
            facilitatorIds,
            memberIds: selectedMemberIds,
          };

          const updatedGroups = state.data.groups.map((group) => ({
            ...group,
            memberIds: group.memberIds.filter(
              (memberId) => !selectedMemberIds.includes(memberId),
            ),
          }));

          return {
            data: {
              ...state.data,
              groups: [...updatedGroups, newGroup],
            },
          };
        }),
      addFacilitator: (facilitatorId, name) =>
        set((state) => {
          const updatedFacilitators = state.data.facilitators.map((fac) =>
            fac.id === facilitatorId ? { ...fac, name } : fac,
          );

          return {
            data: {
              ...state.data,
              facilitators: updatedFacilitators,
            },
          };
        }),
      hasSeenWelcome: false,
      setHasSeenWelcome: (value) => set({ hasSeenWelcome: value }),
      hasStartedFacilitatorProgram: false,
      setHasStartedFacilitatorProgram: (value) =>
        set({ hasStartedFacilitatorProgram: value }),
      lastVisitedFacilitatorRoute:
        '/facilitator/introduction/module-objectives',
      setLastVisitedFacilitatorRoute: (route) =>
        set({ lastVisitedFacilitatorRoute: route }),
      facilitatorPreTrainingSurvey: null,
      hasCompletedFacilitatorPreTrainingSurvey: false,
      submitFacilitatorPreTrainingSurvey: (responses) =>
        set({
          facilitatorPreTrainingSurvey: responses,
          hasCompletedFacilitatorPreTrainingSurvey: true,
        }),
      facilitatorPostTrainingSurvey: null,
      hasCompletedFacilitatorPostTrainingSurvey: false,
      submitFacilitatorPostTrainingSurvey: (responses) =>
        set({
          facilitatorPostTrainingSurvey: responses,
          hasCompletedFacilitatorPostTrainingSurvey: true,
        }),
      hasWatchedFacilitatorTrainingVideo: false,
      setHasWatchedFacilitatorTrainingVideo: (value) =>
        set({ hasWatchedFacilitatorTrainingVideo: value }),
      resetStore: () =>
        set({
          data: initialData,
          hasSeenWelcome: false,
          hasStartedFacilitatorProgram: false,
          lastVisitedFacilitatorRoute:
            '/facilitator/introduction/module-objectives',
          facilitatorPreTrainingSurvey: null,
          hasCompletedFacilitatorPreTrainingSurvey: false,
          facilitatorPostTrainingSurvey: null,
          hasCompletedFacilitatorPostTrainingSurvey: false,
          hasWatchedFacilitatorTrainingVideo: false,
        }),
      updateUserGroups: (userId, selectedGroupIds) =>
        set((state) => {
          const normalizedGroupIds = Array.isArray(selectedGroupIds)
            ? selectedGroupIds
            : selectedGroupIds
              ? [selectedGroupIds]
              : [];
          const updatedGroups = state.data.groups.map((group) => {
            const isInSelected = normalizedGroupIds.includes(group.id);

            const memberExists = group.memberIds.includes(userId);
            if (isInSelected && !memberExists) {
              return { ...group, memberIds: [...group.memberIds, userId] };
            } else if (!isInSelected && memberExists) {
              return {
                ...group,
                memberIds: group.memberIds.filter((id) => id !== userId),
              };
            }
            return group;
          });

          return {
            data: {
              ...state.data,
              groups: updatedGroups,
            },
          };
        }),
    }),

    {
      name: 'facilitator-storage', // unique key in localStorage
      getStorage: () => localStorage, // (default, but explicit here)
    },
  ),
);
